import { render, staticRenderFns } from "./CocForm.vue?vue&type=template&id=2ce84f5f&scoped=true"
import script from "./CocForm.vue?vue&type=script&lang=js"
export * from "./CocForm.vue?vue&type=script&lang=js"
import style0 from "./CocForm.vue?vue&type=style&index=0&id=2ce84f5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce84f5f",
  null
  
)

export default component.exports